import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Pane, Spinner, Text } from "evergreen-ui";
import AccountingContext from "../../contexts/accounting";

const AccountingFailureScreen = ({ basename }) => {
  const { setSystem } = useContext(AccountingContext);
  const [redirect, setRedirect] = useState();

  useEffect(() => {
    setSystem();
    setTimeout(() => {
      setRedirect(<Redirect push to={`${basename}/integrations`} />);
    }, 2500);
  }, [basename, setSystem]);

  if (redirect) {
    return redirect;
  }

  return (
    <Pane alignItems="center" display="flex">
      <Spinner />
      <Text marginX={8}>Redirecting you to integrations...</Text>
    </Pane>
  );
};

export default AccountingFailureScreen;
